import { SideNavActions, SideNavActionTypes } from "./side-nav.actions";
import { logger } from "src/app/modules/logging/logger.reference";

export const sideNavFeatureKey = "sideNav";

export interface SideNavState {
  expanded: boolean;
}

export const initialSideNavState: SideNavState = { expanded: true };

export function sideNavReducer(
  state = initialSideNavState,
  action: SideNavActions,
): SideNavState {
  switch (action.type) {
    case SideNavActionTypes.SetNavState:
      logger.debug(`STORE: ${sideNavFeatureKey} set to`, action.state);
      return action.state;

    case SideNavActionTypes.SetExpanded:
      const expanded = action.expanded;
      logger.debug(`STORE: ${sideNavFeatureKey}.expanded set to`, expanded);
      return Object.assign({}, state, { expanded });

    default:
      return state;
  }
}
